import { cloneDeep } from 'lodash';
import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byUserProfileId: {},
    segments: {
        organized: {}
    }
});

const addUserEventToState = (state, userEvent) => {
    // add event to byUserProfileId
    if (typeof state.byUserProfileId[userEvent.userProfileId] === 'undefined') {
        state.byUserProfileId[userEvent.userProfileId] = {};
    }

    state.byUserProfileId[userEvent.userProfileId][userEvent._id] = userEvent;
};

export default (state = getInitialState(), action) => {
    switch (action.type) {
        case ACTIONS.GET_MANY_USER_EVENTS: {
            const { userEvents } = action.payload;
            const newState = cloneDeep(state);

            userEvents.forEach((item) => {
                addUserEventToState(newState, item);
            });

            return newState;
        }

        case ACTIONS.GET_USER_EVENT:
        case ACTIONS.PUT_USER_EVENT_SUCCESS:
        case ACTIONS.POST_USER_EVENT_SUCCESS: {
            const { userEvent } = action.payload;
            const newState = cloneDeep(state);

            addUserEventToState(newState, userEvent);

            return newState;
        }
        default:
            return state;
    }
};
